import { replace, toLower, toUpper, trim } from 'lodash/fp';

/**
 * To Title Case 2.1
 * copyright 2008-2013 David Gouch. Licensed under the MIT License.
 *
 * @see {@link http://individed.com/code/to-title-case/|Homepage}
 * @see {@link https://github.com/gouch/to-title-case|Github}
 * @param {string} text - Text to transform.
 */
// @ts-expect-error - Automatic, Please fix when editing this file
export function toTitleCase(text) {
  const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
  const output = trim(text);

  return replace(
    /[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g,
    (match, index, title) => {
      if (
        index > 0 &&
        index + match.length !== title.length &&
        match.search(smallWords) > -1 &&
        title.charAt(index - 2) !== ':' &&
        (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
        title.charAt(index - 1).search(/[^\s-]/) < 0
      ) {
        return toLower(match);
      }

      if (match.substr(1).search(/[A-Z]|\../) > -1) {
        return match;
      }

      return toUpper(match.charAt(0)) + match.substr(1);
    },
    output,
  );
}
